module.exports = __webpack_public_path__ + "img/Schlafwagen.7521afda.jpg";